<template>
  <div class="onLineDrugTable">
    <div class="top">
      <slot name="prescriptionBtn"></slot>
      <a-button type="link" v-if="presVisible" @click="emit('prescription')">查看处方详情</a-button>
    </div>
    <a-table
      :bordered="true"
      :pagination="false"
      :rowKey="(record, index) => index"
      :transformCellText="({ text }) => (text ? text : '--')"
      :columns="
        isCHINESE
          ? instanceBusinessType === 1
            ? onLineRecordConf.AGREEMENT_DRUG
            : onLineRecordConf.CHINESE_DRUG
          : onLineRecordConf.WESTERN_DRUG
      "
      :data-source="_normalizedList"
    >
      <template #price="{ record }">
        {{ record.price ? (record.price * 0.01).toFixed(2) : '--' }}
      </template>
      <template #gram="{ record }">
        {{ record.gram ? (record.gram * 1).toFixed(2) : '--' }}
      </template>
    </a-table>
    <div v-if="isCHINESE" class="chineseInfo">
      <div class="infoItem" v-for="(e, i) in onLineData" :key="i">
        <span>
          {{
            e.value === 'taboo' && props?.info?.chineseMedicineInfo?.usage
              ? getTitle(props.info.chineseMedicineInfo.usage)
              : e.label
          }}：
        </span>
        <!-- <span>{{ e.label }}：</span> -->
        <span>{{ _normalizeField(props.info, e.value) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, computed, ref, watchEffect } from 'vue'
import { onLineRecordConf } from './DetailConf'
import { getEntrust, getTitle } from '@/utils/index'
const onLineData = ref(onLineRecordConf.CHINESE_DRUG_ADD)
const emit = defineEmits(['prescription'])
const props = defineProps({
  info: {
    type: [Object],
    default: () => {}
  },
  source: {
    type: [Array, Object],
    default: () => []
  },
  isCHINESE: {
    type: Boolean,
    default: true
  },
  // 判断是否有 prescriptionNumber 决定是否显示
  presVisible: {
    type: Boolean,
    default: true
  },
  // 历史中药处方是否是协定方 1:协定方
  instanceBusinessType: {
    type: Number,
    default: 0
  }
  //
})
watchEffect(() => {
  switch (props.instanceBusinessType) {
    // 协定方
    case 1:
      onLineData.value = onLineRecordConf.AGREEMENT_DRUG_ADD
      break
    default:
      // 中药
      onLineData.value = onLineRecordConf.CHINESE_DRUG_ADD
      break
  }
})

// 兼容处理中药西药传入格式
const _normalizedList = computed(() => {
  if (props.source === null) return []
  return props.source instanceof Array ? props.source : props.source.medicineDetail
})

// 字段显示规则
const _normalizeField = (D, key) => {
  const { chineseMedicineInfo = {} } = D
  if (key === 'taboo') {
    return getEntrust(D['taboo'], D['advice'])
  } else if (key === 'cycle') {
    const { usage = {} } = chineseMedicineInfo
    if (JSON.stringify(usage) !== '{}') {
      return usage.cycle + usage.cycleUnit
    } else {
      return '--'
    }
  } else {
    if (
      chineseMedicineInfo === null ||
      JSON.stringify(chineseMedicineInfo) === '{}' ||
      !chineseMedicineInfo[key]
    )
      return '--'
    // 嘱托改为原来的服用禁忌+医嘱
    return chineseMedicineInfo[key]
  }
}
</script>

<style lang="scss" scoped>
.onLineDrugTable {
  .top {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .baseTitle {
    font-size: 16px;
    font-weight: 550;
    color: #000000;
    margin-bottom: 25px;
  }
  .chineseInfo {
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #f0f0f0;
    border-top: none;
    border-radius: 0 0 4px 4px;
    padding: 20px 16px 0px;
    .infoItem {
      width: 50%;
      margin-bottom: 20px;

      span:nth-of-type(1) {
        font-weight: 550;
        color: #333333;
      }
      span:nth-of-type(2) {
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
</style>
